/** One in-flight load of tenant + user context for this page load. */
let platformSessionPromise: Promise<void> | null = null;

/** Allow the next login in this tab to load user context again. */
export function resetPlatformSessionHydration(): void {
  platformSessionPromise = null;
}

/**
 * Run `load` once per page load. Later calls, including a remount when the
 * window regains focus, reuse the same result instead of calling user context again.
 */
export function loadPlatformSessionOnce(
  load: () => Promise<void>,
): Promise<void> {
  if (!platformSessionPromise) {
    platformSessionPromise = load().catch((error) => {
      platformSessionPromise = null;
      throw error;
    });
  }
  return platformSessionPromise;
}
